import {
  UserLoggedInNavigatorNavigationProp,
  UserLoggedInNavigatorParamList,
} from "../../TopLevelNavigators/UserLoggedIn/UserLoggedInNavigatorParamList";
import {
  NativeStackNavigationProp,
  createNativeStackNavigator,
} from "@react-navigation/native-stack";
import { CompositeNavigationProp } from "@react-navigation/native";

export type NavProp<T extends keyof ParamList> = CompositeNavigationProp<
  UserLoggedInNavigatorNavigationProp<"TeamScheduleHistory">,
  NativeStackNavigationProp<ParamList, T>
>;
export const Stack = createNativeStackNavigator<ParamList>();
export type ParamList = {
  TeamScheduleHistoryScreen: UserLoggedInNavigatorParamList["TeamScheduleHistory"] & {
    currentId?: string;
  };
  TeamScheduleHistoryScreenList: {
    teamId: string;
    freq: "DAILY" | "WEEKLY" | "MONTHLY";
  };
  TeamScheduleHistoryScreenDetail: {
    teamId: string;
    id: string;
  };
};
